<ion-fab vertical="top" horizontal="end" slot="fixed" (click)="close()">
  <ion-fab-button>
    <ion-icon name="close" />
  </ion-fab-button>
</ion-fab>

<lib-pinch-zoom backgroundColor="transparent">
  <ion-img [src]="imageUrl()" />
</lib-pinch-zoom>
